import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatTooltipModule } from '@angular/material/tooltip';
import { GridComponentModule } from '@portal-core/ui/grid/components/grid/grid.module';
import { GridCellModule } from '@portal-core/ui/grid/directives/grid-cell/grid-cell.module';
import { VariablesGridComponent } from './variables-grid.component';

@NgModule({
  declarations: [
    VariablesGridComponent,
  ],
  imports: [
    CommonModule,
    GridCellModule,
    GridComponentModule,
    MatRadioModule,
    MatButtonModule,
    MatCheckboxModule,
    MatTooltipModule
  ],
  exports: [
    VariablesGridComponent
  ]
})
export class VariablesGridModule { }
